module.exports = __webpack_public_path__ + "media/images/home/feature/functions-f4b1bc4992965afc4f9563e17b62e18e.jpg";